import styled from "styled-components";

import React from "react";
import PropTypes from "prop-types";
import bookmarkFill from "../../../assets/images/temp/bookmark-fill.svg";
import bookmarkEmpty from "../../../assets/images/temp/bookmark-empty.svg";

const BookmarkImg = styled.img`
  width: 14px;
  height: 20px;
`;

const BookmarkIcon = ({ isBookmarked }) => (
  <BookmarkImg src={isBookmarked ? bookmarkFill : bookmarkEmpty} alt="Bookmark icon" />
);

BookmarkIcon.propTypes = {
  isBookmarked: PropTypes.bool,
};

export default BookmarkIcon;
